export default "__VITE_ASSET__CNuYGOAN__"